/*-------------------------------------------- */
/** Globals */
/*-------------------------------------------- */
import './globals/auth'
import './globals/auth-ui'
import './globals/format-money'
import './globals/header-promo-bar'
import './globals/header-breed-nav'
import './globals/header-account'
import './globals/header-nav-desktop'
import './globals/header-nav-mobile'

/*-------------------------------------------- */
/** Lib */
/*-------------------------------------------- */


/*-------------------------------------------- */
/** Components */
/*-------------------------------------------- */
import './components/cart-message'
import './components/hero-full-banner'
import './components/hero-multi-banner'
import './components/hero-half-banner'
import './components/cart-hover'
import './components/quantity-selector'
import './components/product-carousel'
import './components/curated-collection'
import './components/recently-viewed-products'
import './components/shop-by-breed'
import './components/single-product-call-out'
import './components/customer-reviews'

/*-------------------------------------------- */
/** Router */
/*-------------------------------------------- */
import('./router').then((router) => {
  router.init()
})
